import React, { useState, useEffect, useRef } from 'react';
import './App.css'
import SwaggerUI from 'swagger-ui';
import Config from './organization_config.json';
import Sidebar from './Sidebar.js'
import { fetchAndConvertAPI } from './apiConverter.js';
import '../node_modules/swagger-ui/dist/swagger-ui.css'

function App() {
  const [organizationConfig] = useState(Config.orgData);
  const [definitionList, setDefinitionList] = useState(null);
  const [definitionLink, setDefinitionLink] = useState("/swagger.json");
  const [convertedSpec, setConvertedSpec] = useState(null);
  const swaggerContainerRef = useRef(null);

  useEffect(() => {
    // Only render SwaggerUI if we have a valid external Swagger URL
    if (definitionLink && definitionLink !== "/swagger.json") {
      // Clear the container before rendering new SwaggerUI
      const container = document.getElementById("api-data");
      if (container) {
        container.innerHTML = '';
        
        // Check if we have a converted specification
        if (convertedSpec) {
          SwaggerUI({
            domNode: container,
            spec: convertedSpec,
            supportedSubmitMethods: ['get', 'post', 'put', 'delete', 'patch'],
            docExpansion: 'list',
            defaultModelsExpandDepth: 1,
            defaultModelExpandDepth: 1,
            displayRequestDuration: true,
            showExtensions: true,
            showCommonExtensions: true,
            validatorUrl: null,
            oauth2RedirectUrl: window.location.origin + '/swagger-ui/oauth2-redirect.html'
          });
        } else {
          // Fallback to URL-based loading
          SwaggerUI({
            domNode: container,
            url: definitionLink,
            supportedSubmitMethods: ['get', 'post', 'put', 'delete', 'patch'],
            docExpansion: 'list',
            defaultModelsExpandDepth: 1,
            defaultModelExpandDepth: 1,
            displayRequestDuration: true,
            showExtensions: true,
            showCommonExtensions: true,
            validatorUrl: null,
            oauth2RedirectUrl: window.location.origin + '/swagger-ui/oauth2-redirect.html'
          });
        }
      }
    }
  }, [definitionLink, convertedSpec]);

  const swaggerhub = (inputMethod, inputResource, inputParams) => {
    let url = "";
    if (inputParams) {
      url = "https://api.swaggerhub.com/apis/" + inputResource + "?" + inputParams;
    } else {
      url = "https://api.swaggerhub.com/apis/" + inputResource;
    }

    return fetch(url, {
      method: inputMethod
    }).then(response => {
      if (response.ok) {
        return response.json();
      } 
      throw new Error('There was an issue requesting the API');
    }).then(json => {
      return json;
    });
  };

  const getOrganizationData = (organization) => {
    let inputParams = "page=0&limit=10&sort=NAME&order=ASC";
    let inputResource = organization;
    fetch("/swagger.json")
    .then((response) => response.json())
    .then(res => {
      setDefinitionList(res.swagger_list);
    });
  };

  const updateDefinitionLink = async (newLink) => {
    setDefinitionLink(newLink);
    setConvertedSpec(null); // Reset converted spec
    
    // If it's an external URL, try to convert it
    if (newLink && newLink !== "/swagger.json" && newLink.startsWith('http')) {
      try {
        const converted = await fetchAndConvertAPI(newLink);
        setConvertedSpec(converted);
      } catch (error) {
        console.error('Failed to convert API:', error);
        // Continue with original URL if conversion fails
      }
    }
  };

  return (
    <div className="App">
      <Sidebar
        organizationConfig={organizationConfig}
        definitionList={definitionList}
        updateDefinitionLink={updateDefinitionLink}
        getOrganizationData={getOrganizationData}
      />
      <div id="api-data">
        {definitionLink === "/swagger.json" && (
          <div className="welcome-message">
            <h2>Welcome to IPSS API Documentation</h2>
            <p>Please select an API from the sidebar to view its documentation.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;